module.exports = __webpack_public_path__ + "static/media/stats4.3aec5b46.png";